import { styled } from 'naan/stitches.config';

export const Body = styled('div', {
  padding: '0 $space$4 $space$4',
  '&:first-child': {
    paddingTop: '$space$4',
  },
});
